import { msg } from '@lingui/macro';
import { IconClipboardList } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productListImport',
  status: 'active',
  category: 'other',
  icon: IconClipboardList,
  title: msg`Product list`,
  shortTitle: msg`Add to a product list`,
  whenToUse: msg`Add products to an existing product list (for an event, tasting, catalogue, or selection).`,
  outputDescription: msg`Adds products to a chosen list.`,
  intents: [
    'Add wines to an event list',
    'Build a tasting selection',
    'Add products to a catalogue list',
    'Bulk-add to an existing product list',
  ],
  keywords: [
    'product list',
    'event',
    'tasting',
    'selection',
    'curated',
    'add',
    'catalogue',
  ],
  synonyms: ['fair list', 'event list', 'show list'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Product External ID', 'Product name'],
    requiredColumns: ['Product External ID'],
  },
};

export default descriptor;
